import { Routes } from '@angular/router';

export const ORTHOPHOTO_ROUTES: Routes = [
	{
		path: 'ortofoto',
		loadComponent: () => import('./feature-ortofoto/ortofoto').then((m) => m.Ortofoto),
		data: { title: 'Ortofotos' },
	},
];
